/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Answering cards and Activity's rows: add (Add, Send, Move or Update; with
 * edits, Change it first), not_now, try_again (one that failed) or cancel
 * (one scheduled for later). ids are the cards' ids. edits, for one task or
 * CRM card: a task's name, content, due_date (ISO), assigned and about
 * (keys); a move's column ("board_id:column_id") and values; an update's
 * values (as the step's config takes them).
 */
export type CardAnswer = {
  ids: Array<string>;
  answer: CardAnswer.answer;
  edits?: null;
};

export namespace CardAnswer {
  export enum answer {
    ADD = "add",
    NOT_NOW = "not_now",
    TRY_AGAIN = "try_again",
    CANCEL = "cancel",
  }
}
